import { Zone } from './user.entity';

export interface A0 {
  id?: string;
  title?: string;
  author?: string;
  author_login?: string;
  name_zone?: string;
  type_zone?: string;
  code_zone?: string ;
  type_risque: string;
  created_at?: string;
  updated_at?: string;
  pdf_url?: string;
  pdf_generationdate?: string;
  url_labels_svg?: string;
  url_ccm?: string;
  url_entete?: string;
  url_legend_dynamic?: string;
  url_legend_static?: string;
  url_echelle?: string;
  url_strategiecom?: string;
  id_user?: number;
  name_user?: string;
  list_zone?: Zone[];
}

export enum SnapshotType {
  MAIN = 'MAIN',
  ZOOM_1 = 'ZOOM_1',
  ZOOM_2 = 'ZOOM_2',
}

export enum ModuleType {
  MODULE_LEGENDE_STATIC = 'MODULE_LEGENDE_STATIC',
  MODULE_STRATEGIE_ALERTE_COMMUNALE = 'MODULE_STRATEGIE_ALERTE_COMMUNALE',
  MODULE_ALL_TITLES = 'MODULE_ALL_TITLES',
  MODULE_CUSTOM = 'MODULE_CUSTOM'
}

export enum PlanAction {
  CCM = 'ccm',
  ENTETE = 'entete',
  ENJEUX = 'legend_dynamic',
  LEGEND_STATIC = 'legend_static',
  ECHELLE = 'echelle',
  STRATEGIE_COM = 'strategiecom',
  MAP = 'map'
}

export interface Snapshot {
  id_zoom: string;
  mapA0: string;
  snapshot_url_image: string;
  snapshot_url_image_lite?: string;
  snapshot_date: string;
  position: string;
  is_custom_upload: boolean;

  // 3D Camera ou 2D bbox
  bbox: string;

  pictos?: any[];
  arrow_position?: string;
  scale_position?: string;
  title_position?: string;
  title?: string;
}

export interface Module {
  id: string;
  id_module: string;
  mapA0: string;
  position: string;
  url?: string;
}

export interface ModuleTitleItem {
  id?: number;
  name: string;
  fontSize: number;
  color: string;
  shadow: boolean;
  position: string;
}
